import { actionCreator } from '@blink/components/src/utils';

import { GET_ME, SET_ME } from './constants';
import { Me } from 'src/api/info';

export const getMeAction = () => actionCreator(GET_ME);

export const setMeAction = (payload: Me) => actionCreator(SET_ME, payload);
